import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { H3, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import { pushLoginExpressEditUserDetailsClickEventToDataLayer } from '../../../../data-layer.js';
import { useFormSlotWithoutRedux } from '../../../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../../../slots/summaries/summary-context.js';
import '../../../../slots/summaries/types.js';
import { seedFieldState } from '../../../../StepShipping/mappers/seed-shipping-form.js';
import { useLoggedInCheckout } from '../../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';
import { formStatesToValues } from '../../../utils/form-state-to-values.js';
import { isFormDataValid } from '../../../utils/validate-form-data.js';

const InvoiceSummary = ({ invoiceDetails , onSubmit , isOrderDetailsValid  })=>{
    const { getLabel  } = useIntl();
    const { formFieldsMap  } = useCheckoutSettings();
    const { isUserLoggedIn  } = useLoggedInCheckout();
    const { Slots  } = useBaseSummarySlot();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const filledFormData = invoiceDetails && Object.entries(invoiceDetails).reduce((item, [key, value])=>swcHelpers.objectSpread({}, item, {
            [key]: seedFieldState(key, value)
        })
    , {});
    const [invoiceDetailsState, setInvoiceDetailsState] = React.useState();
    const handleSubmit = React.useCallback((invoiceFormState)=>{
        const updatedInvoiceDetails = invoiceDetailsState && formStatesToValues(invoiceFormState.formState);
        updatedInvoiceDetails && (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
            invoice: updatedInvoiceDetails
        }));
        setIsModalOpen(false);
    }, [
        invoiceDetailsState,
        onSubmit
    ]);
    const { invoice: invoiceForm  } = useFormSlotWithoutRedux({
        formInitialData: filledFormData ? {
            invoice: filledFormData
        } : {},
        onChange: setInvoiceDetailsState,
        onSubmit: handleSubmit,
        onCancel: ()=>setIsModalOpen(false)
        ,
        className: 'login-express-checkout__form-modal__form login-express-checkout__form-modal__form--with-custom-height'
    });
    const labels = {
        title: getLabel('checkout.invoice.label'),
        save: getLabel('common.actions.save')
    };
    const isInvoiceDetailsFormComplete = React.useMemo(()=>{
        var ref;
        return (formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.invoice) ? (ref = isFormDataValid(formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.invoice, invoiceDetails)) !== null && ref !== void 0 ? ref : false : false;
    }, [
        invoiceDetails,
        formFieldsMap === null || formFieldsMap === void 0 ? void 0 : formFieldsMap.invoice
    ]);
    const onEditHandler = React.useCallback(()=>{
        pushLoginExpressEditUserDetailsClickEventToDataLayer({
            editType: isInvoiceDetailsFormComplete ? 'edit_invoice' : 'add_invoice_alert',
            isLoggedIn: isUserLoggedIn
        });
        setIsModalOpen(true);
    }, [
        isInvoiceDetailsFormComplete,
        isUserLoggedIn
    ]);
    if (!Slots.invoice) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        className: "login-express-checkout__form-modal",
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true
    }, /*#__PURE__*/ React.createElement(H3, {
        variant: "body-head"
    }, labels.title), /*#__PURE__*/ React.createElement(React.Fragment, null, invoiceForm)), /*#__PURE__*/ React.createElement(Slots.invoice, {
        actions: {
            onEdit: onEditHandler
        },
        values: invoiceDetails,
        errorNotification: !isInvoiceDetailsFormComplete ? /*#__PURE__*/ React.createElement(Alert, {
            className: "alert-m-default ",
            role: isOrderDetailsValid ? 'status' : 'alert',
            variant: isOrderDetailsValid ? 'info' : 'error',
            title: getLabel('checkout.invoice.incomplete.title')
        }, getLabel('checkout.information.incomplete.message')) : null
    }));
};

export { InvoiceSummary };
//# sourceMappingURL=InvoiceSummary.js.map
